<template>
  <hr
    class="jade-divider"
    :class="computedClassList"
    role="separator"
  />
</template>

<script>
import SIZE_ENUM from '../enums/sizes.enum'
import DIRECTION_ENUM from '../enums/direction.enum'

export default {
  name: 'JadeDivider',

  props: {
    direction: {
      type: String,
      validation: direction =>
        Object.values(DIRECTION_ENUM).includes(direction),
      default: DIRECTION_ENUM.HORIZONTAL
    },
    size: {
      type: String,
      validation: size =>
        Object.values([
          SIZE_ENUM.LARGE,
          SIZE_ENUM.MEDIUM,
          SIZE_ENUM.SMALL
        ]).includes(size),
      default: SIZE_ENUM.SMALL
    }
  },

  computed: {
    computedClassList () {
      return {
        [`is-${this.direction}`]: this.direction,
        [`is-${this.size}`]: this.size
      }
    }
  }
}
</script>
<style scoped>
@import '@stone-payments/jade/css/divider.css';
</style>
